import { sprinkles } from '@design-system/sprinkles.css';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack } from '@mui/material';

import wireIcon from './Wire.svg';

export const WirePaymentMethod: React.FC = () => {
  return (
    <div>
      <img src={wireIcon} />
      <Stack direction="row" alignItems="center" gap={1} className="mt-4">
        <FontAwesomeIcon icon={faCircleCheck} color="#00CB20" />
        <span
          className={sprinkles({
            fontFamily: 'visuelt',
            fontWeight: 'bold',
            fontSize: 'm',
          })}
        >
          Bank transfer connected
        </span>
      </Stack>
      <p
        className={`${sprinkles({
          fontFamily: 'visuelt',
          fontSize: 's',
        })} mt-4`}
      >
        Contact our{' '}
        <a
          href="mailto:creatorsupport@playbookapp.io"
          className="underline text-inherit"
        >
          support team
        </a>{' '}
        for other payment method.
      </p>
    </div>
  );
};
